import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the GestionporproductoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-gestionporproducto',
  templateUrl: 'gestionporproducto.html',
})
export class GestionporproductoPage {
  descripcion: string = '';
  listaProductosSeleccionados = []
  infoResponse = []
  item: any
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public viewControllers:ViewController) {
    if(this.navParams.get('listaProductosSeleccionados')){
      this.listaProductosSeleccionados =   this.navParams.get('listaProductosSeleccionados')
      this.item =   this.navParams.get('item')

      if(this.item.index !== undefined) {
        this.listaProductosSeleccionados = this.listaProductosSeleccionados.filter((values)=> values.index == this.item.index)
      } else {
        this.listaProductosSeleccionados = this.listaProductosSeleccionados.filter((values)=> values.comandasId == this.item.comandasId)
      }

      this.descripcion =  this.listaProductosSeleccionados[0].descripcion

    } else {
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GestionporproductoPage');
  }
  insertResponse(name, value) {
    this.infoResponse.push({
    'name': name,
    'value': value
    })
  }
  dismiss(){
    this.cerrarModal()
  }

  submit(){
    this.cerrarModal()
  }
  cerrarModal() {
    this.insertResponse('descripcion', this.descripcion)
    if(this.listaProductosSeleccionados.length>0) {
      this.insertResponse('listaProductosSeleccionados', this.listaProductosSeleccionados)
    }
    this.viewControllers.dismiss(this.infoResponse);
  }
}



// WEBPACK FOOTER //
// ./src/pages/gestionporproducto/gestionporproducto.ts